import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { alertMessageState, loadingState } from "src/atom/LoadingState";
import callApi from "src/services/Common/api";

export default function PaymentStatus() {
  const advtId = process.env.REACT_APP_AVT;
  const enableLoader = useSetRecoilState(loadingState);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    var fetchdetails = async () => {
      enableLoader(true);
      const responseData = await callApi(
        `/v1/api/getPages/${advtId}`,
        "GET",
        null,
        true,
        setAlertMessage
      );
      if (responseData.success != false) {
        const body = responseData?.body[0];
        const milestoneList = body?.milestones;
        const id = body?.id;
        for (let index = 0; index < milestoneList.length; index++) {
          var mile = milestoneList[index];
          if (mile.name !== "Payment") {
            if (!mile.status) {
              navigate("/application-form", {
                state: {
                  body: milestoneList,
                  pageId: id,
                  activeIndex: 0,
                },
              });
              break;
            }
          } else {
            navigate("/application-form", {
              state: {
                body: milestoneList,
                pageId: id,
                activeIndex: 6,
              },
            });
            break;
          }
        }
      }
      enableLoader(false);
    };
    fetchdetails();
  };

  return <></>;
}
